import React, { useState } from "react";
import { Alert, Button, Typography, Stack, FormControl, FormLabel, RadioGroup, Radio, FormControlLabel } from "@mui/material";
import { useQuery } from "@apollo/client";
import { APPOINTMENT_PROVIDERS } from "../../graphql/stripePayments";
export default function CustomerPaymentPage({ disabled, onApprove, businessUrl }) {
  const [selected, setSelected] = useState("");
  const { data, loading, error, refetch } = useQuery(APPOINTMENT_PROVIDERS, { variables: { businessUrl }, skip: !businessUrl, fetchPolicy: "network-only" });
  const providers = data?.appointmentPaymentProviders || [];
  const provider = providers.includes(selected) ? selected : providers[0];
  return <Stack spacing={1}>
    {providers.length > 0 && <FormControl><FormLabel>Payment method</FormLabel><RadioGroup value={provider} onChange={event => setSelected(event.target.value)}>
      {providers.map(code => <FormControlLabel key={code} value={code} disabled={disabled} control={<Radio />} label={code === "STRIPE" ? "Debit or credit card (Stripe)" : "PayPal"} />)}
    </RadioGroup></FormControl>}
    {error && <Alert severity="error">Payment methods could not be loaded. <Button onClick={() => refetch()}>Try again</Button></Alert>}
    {!loading && !error && !providers.length && <Alert severity="info">This business is not accepting online payments right now. Please contact them to arrange your booking.</Alert>}
    <Button variant="contained" disabled={disabled || loading || !provider || Boolean(error)} onClick={() => onApprove(provider)}>
      {loading ? "Loading payment methods…" : provider === "PAYPAL" ? "Continue to PayPal" : "Continue to secure payment"}
    </Button>
    <Typography variant="caption" color="text.secondary">Your appointment is confirmed after payment.</Typography>
  </Stack>;
}
